const ScrollManager = {
    /**
     * Incrémenté par la méthode preventScroll.
     * Scroll de la page bloqué lorsqu'elle est supérieur à 0.
     */
    preventScrollCounter: 0,
    
    /**
     * Bloque ou débloque le scroll de la page
     * 
     * @param {boolean} state true = scroll bloqué / false = scroll débloqué
     * 
     * @return {ScrollManager}
     */
    preventScroll(state) {
        if (state) {
            this.preventScrollCounter++;
        } else if (this.preventScrollCounter > 0) {
            this.preventScrollCounter--;
        }

        if (this.preventScrollCounter > 0) {
            document.body.classList.add('prevent-scroll');
        } else {
            document.body.classList.remove('prevent-scroll');
        }

        return this;
    },

    /**
     * Scroll vers un offset ou un élément
     * 
     * @param {HTMLElement|number} $element 
     * 
     * @return {ScrollManager}
     */
    scrollTo($element) {
        const posY = typeof $element === 'number' ? $element : $element.getBoundingClientRect().top + window.scrollY - 100;

        window.scroll(0, posY);

        return this;
    },
};

export default ScrollManager;
